import React from 'react';
import SelectableTable from '../SelectableTable/Main.js';
import InputFormTable from '../InputFormTable/Main.js';
import UploadForm from '../UploadForm/Main.js';
import { connect } from 'react-redux';
import { linkHeaderAction } from '../../redux/ui/actions';
import { changeSwModeAction } from '../../redux/app/actions';
import Sw from '../common/Sw';


const initData = {
    boringFiles: [
        {
            type: "gakkai",
            path: "sapporo.csv",
            size: 100,
            date: "2020-09-08"
        },
        {
            type: "gakkai",
            name: "oosaka.csv",
            size: 200,
            date: "2020-09-09"
        },
        {
            type: "idojibiki",
            name: "sapporo.csv",
            size: 100,
            date: "2020-09-08"
        },
    ]
};


class Main extends React.Component {
    /*★ここから公開版で削除*/
    constructor(props) {
        console.log("BoringDBEditor constructor");
        super(props);
        this.state = {
            boringFiles: initData["boringFiles"],
            selected: null,
            selectedFile: null,
            mode: "list",
        };
    }

    /*
     * 環境情報取得
     * boringFilesフォーマットは
     * initData["boringFiles"]と同じ
     */
    loadBoringFiles = async () => {
        const origin = window.location.origin;
        await fetch(`${origin}/api/boringfiles`)
            .then(res => res.json())
            .then(res => {
                console.log("loadBoringFiles", JSON.stringify(res));
                this.setState({ boringFiles: res["boringFiles"] });
            })
            .catch(err => console.log(err));
        console.log("BoringDBEditor loadBoringFiles done");
    }

    async componentDidMount() {
        console.log("BoringDBEditor componentDidMount");
        await this.loadBoringFiles();
    }

    /* ボーリングファイル一覧画面のイベントハンドラ */
    //ボーリングファイル新規登録画面へ遷移
    onAdd = (e) => {
        console.log("onAdd");
        this.setState({ mode: "add" });
    }

    //ボーリングファイルの削除
    onDelete = async (e) => {
        if (!window.confirm("本当に削除しますか?")) {
            return;
        }

        console.log("onDelete:", JSON.stringify(this.state.selected));

        if (!this.state.selected) {
            return;
        }

        const origin = window.location.origin;
        await fetch(`${origin}/api/boringfiles`,
            {
                method: "DELETE",
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(this.state.selected)
            })
            .then(res => res.json())
            .then(res => {
                this.setState({
                    boringFiles: res["boringFiles"],
                    mode: "list",
                    selectedFile: null,
                    selected: null
                });
            })
            .catch(err => console.log(err));

    }

    //ボーリングファイルのマージ
    onMerge = async (e) => {
        const origin = window.location.origin;
        await fetch(`${origin}/api/boringfiles`,
            {
                method: "PUT",
                headers: {
                    'Content-Type': 'application/json',
                },
            })
            .then(res => res.json())
            .then(res => {
            })
            .catch(err => console.log(err));
    }

    //ボーリングファイルの選択
    onBoringFileCheckedChange = (checked, index) => {
        console.log("onBoringFileCheckedChange:", checked, index);
        let selected;
        if (checked) {
            selected = this.state.boringFiles[index];
        } else {
            selected = null;
        }

        console.log("onBoringFileCheckedChange:", JSON.stringify(selected));
        this.setState({ selected: selected });
    }



    /* ボーリングファイル新規登録画面のイベントハンドラ */

    /*
     *ボーリングファイルの追加(POST)
     * POST boringFileフォーマット
    {
       type: "gakkai",
       path: "sapporo.csv",
    }
    */
    onUpdateBoringFile = async (e) => {
        console.log("onUpdateBoringFile:", e["type"], this.state.selectedFile);
        const formData = new FormData();
        formData.append('file', this.state.selectedFile);
        formData.append('type', e["type"]);
        console.log("onUpdateBoringFile formdata:", formData._boundary);

        const origin = window.location.origin;
        await fetch(`${origin}/api/boringfiles`,
            {
                method: 'POST',
                /*
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                */
                body: formData
            })
            .then(res => res.json())
            .then(res => {
                this.setState({
                    boringFiles: res["boringFiles"],
                    mode: "list",
                    selectedFile: null,
                    selected: null
                });
            })
            .catch(err => console.log(err));
    }

    //新規追加のキャンセル
    onCancelEdit = () => {
        this.setState({
            mode: "list",
            selectedFile: null
        });
    }

    //新規追加のキャンセル
    onFileSelected = (file) => {
        console.log(file);
        this.setState({
            selectedFile: file
        });
    }


    render() {
        if (this.state.mode == "list") {
            //ボーリングファイルリスト画面
            return (
                <div>
                    <SelectableTable key="1" inputType="radio" name="boringfiles" onCheckChange={this.onBoringFileCheckedChange} dataList={this.state.boringFiles} />
                    <div className="l-row">
                        <button className="sBtn" key="env add" onClick={this.onAdd}>新規</button>
                        <button className="sBtn l-mlS" key="env del" onClick={this.onDelete}>削除</button>
                        <button className="sBtn l-mlS" key="env del" onClick={this.onMerge}>マージ</button>
                    </div>
                </div>
            );
        } else {
            //ボーリングファイル新規追加画面
            return (
                <Sw title="ボーリングファイル新規追加">
                    <div id="BoringDBEditor">
                        <UploadForm onFileSelected={this.onFileSelected} title="ボーリングファイル選択" />
                        <InputFormTable onClickOK={this.onUpdateBoringFile} onClickCancel={this.onCancelEdit}
                            data={this.state.selected ?
                                this.state.selected
                                :
                                { type: "", name: "", size: "", time: "" }}
                            excludedNames={["name", "size", "time"]}
                        />
                    </div>
                </Sw>
            );
        }
        return (<React.Fragment></React.Fragment>);
    }
}

export default Main;
